document.addEventListener('DOMContentLoaded', function(){
document.querySelectorAll('.product__submit__buttons .btn').forEach(button => {
  button.addEventListener('click', () => {
    setTimeout(() => {
      button.classList.remove('is-loading');
      button.removeAttribute('disabled');
    }, 1000); // 3 seconds delay
  });
});






 






  

});